import React from 'react'
import Paper from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import Draggable from 'react-draggable';
import EmpListContainer from '../../../../containers/common/form/modal/EmpListContainer'
import BootstrapDialog, { BootstrapDialogTitle } from '../../dialog/BootstrapDialog'

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-emp-dialog"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const EmpModal = ({ roleTyp, title, multi, open, handleClose, selectedEmployee }) => {
    return (
        <BootstrapDialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-emp-dialog"
            fullWidth={true}
            maxWidth="md"
        >
            <BootstrapDialogTitle style={{ cursor: 'move' }} id="draggable-emp-dialog" onClose={handleClose}>
                {title}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <EmpListContainer roleTyp={roleTyp} multi={multi} selectedEmployee={selectedEmployee} handleClose={handleClose} />
            </DialogContent>
        </BootstrapDialog>
    )
}

export default EmpModal